import LINK_CONFIG from './env';

/**
 * Completes the single sign-on Amplify configuration with the resolved redirect URLs. Spreads the base AWS config, enables ssr, and points both oauth redirectSignIn and redirectSignOut at the environment's redirect link.
 *
 * @returns The Amplify configuration object with its oauth redirects filled in.
 */
const updatedAwsConfig = () => ({
  ...LINK_CONFIG.AWS_CONFIG,
  ssr: true,
  oauth: {
    ...LINK_CONFIG.AWS_CONFIG.oauth,
    redirectSignIn: LINK_CONFIG.LINK_REDIRECT_AWS,
    redirectSignOut: LINK_CONFIG.LINK_REDIRECT_AWS,
  },
});

export default updatedAwsConfig;
